module.exports = __webpack_public_path__ + "static/ch5-SCENE-01_ARCHIVE-Bloody_Sunday-6da869afff49681b585e823d188ce5ec.mp4";